@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.errorMessage {
  position: absolute;
  padding-top: 2px;
  color: v.$error-color;
  @include t.text(12px, 20px, "medium");

  &.relative {
    position: relative;
  }
}
